import { loadingOrange } from 'assets/Icons'
import Loading from './style'

interface ILoadingPageProps {
  modal?: boolean
  small?: boolean
}

export default function LoadingPage(props: ILoadingPageProps) {
  return (
    <Loading {...props}>
      <img className="loading-img" src={loadingOrange} alt="card icon" />
    </Loading>
  )
}
